import { ARENA_H, ARENA_W, PLAYER } from "../config.ts";

/** The player avatar. Eases toward an input-provided target for a weighty feel. */
export class Player {
  x = ARENA_W / 2;
  y = ARENA_H * 0.78;
  px = this.x;
  py = this.y;
  vx = 0;
  vy = 0;

  lives = PLAYER.startLives;
  invuln = 0; // remaining i-frames (s)
  alive = true;

  reset(): void {
    this.x = this.px = ARENA_W / 2;
    this.y = this.py = ARENA_H * 0.78;
    this.vx = 0;
    this.vy = 0;
    this.lives = PLAYER.startLives;
    this.invuln = 0;
    this.alive = true;
  }

  get invulnerable(): boolean {
    return this.invuln > 0;
  }
}
